/** One line of warning wherever a reviewer meets the offline copy: the
 *  downloaded flight draws the NSW Government maps, not the Esri maps the
 *  live site uses, and those stop at the state border (2026-09-09). */
export function OfflineBasemapNote(): JSX.Element {
  return (
    <p data-testid="offline-basemap-note">
      Downloaded flights use NSW Government imagery and base map instead of the online
      maps. Outside NSW the map is blank offline.
    </p>
  );
}
